export default "__VITE_ASSET__BF$1cpTq__"